// Напускането на листа „Доставка" — общото `useWorksheetLeave`. Нова
// доставка: черновата се пази сама → излизаме тихо (черновата се записва
// веднага). Редакция: при промени питаме „Излизане от редакцията на доставка
// №… без запис?" с редовете в листа.
import type { MutableRefObject } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { summaryLineItem } from "../../components/confirm/confirmPreviews";
import { useWorksheetLeave } from "../../components/drafts/useWorksheetLeave";

// Редовете за въпроса: до 5 „Продукт — количество" + общият им брой
export type DeliveryRowsSummary = { lines: string[]; total: number };

type Params = {
  mode: "new" | "edit";
  dirtyRef: MutableRefObject<boolean>;
  flushDraft: () => Promise<void>;
  onRegisterLeaveGuard?: (guard: ((proceed: () => void) => void) | null) => void;
  describeRows?: () => DeliveryRowsSummary;
};

export const useDeliveryLeave = ({
  mode,
  dirtyRef,
  flushDraft,
  onRegisterLeaveGuard,
  describeRows,
}: Params) => {
  const { t } = useTranslation();
  const { deliveryId } = useParams();
  return useWorksheetLeave({
    mode,
    dirtyRef,
    flushDraft,
    onRegisterLeaveGuard,
    describeUnsaved: () => {
      const rows = describeRows?.();
      return {
        document: t("inventoryPage.cfmDocEditDelivery", { number: deliveryId ?? "" }),
        items: rows?.lines.map(summaryLineItem),
        total: rows?.total,
      };
    },
  });
};
